import * as CONST from "./actionTypes";

const intialState = {
  disputeListData: [],
  disputeViewData: null,
  total: 0,
  loading: false,
};

const disputeReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    //get data
    case CONST.GET_DISPUTES:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_DISPUTES_SUCCESS:
      return {
        ...state,
        disputeListData: payload?.data,
        total: payload.totalcount,
        loading: false,
      };

    case CONST.GET_DISPUTES_FAIL:
      return {
        ...state,
        loading: false,
      };
    // get service by id

    case CONST.GET_DISPUTE_VIEW:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_DISPUTE_VIEW_SUCCESS:
      return {
        ...state,
        disputeViewData: payload,
        loading: false,
      };

    case CONST.GET_DISPUTE_VIEW_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;

      break;
  }
};

export default disputeReducer;
